import { Formik, Form  } from "formik";
import React, {useState,  useRef} from "react";
import  {Box, Button, } from '@mui/material/';
import RadioButton from "../../reportPage/symptoms/Symptom Modal/radiobutton";
import '../../../css/App.css'
import idaThresholds from "../../../utilities/idAnaemia/idaThresholds";


function IronReplacement(props)
{
    let onIronQuestion
    let riseOnIronQuestion

 const [isOnIron,setIsOnIron] =useState(false)
 const formValues = useRef(null)

const initialValues= 
    {
    onIron:"",
    riseOnIron:""
    }

const optionObject=
[{key:"Yes",value:"Yes"},
{key:"No",value:"No"}]


const onClick=()=>
{
const setVals=()=>(updateFunction(formValues.current.values))// allows time for react to update state (tried a useEffect but didn't work)
const delay=()=> setTimeout(setVals,100)
delay()
clearTimeout(delay)
}

const updateFunction=(onIronValue)=>
{
setIsOnIron(formValues.current.values.onIron)
}

const onIron=()=>
    {
    let symptom={}
    symptom.name="onIron"
    symptom.label="Has the patient had recent iron therapy?"
    symptom.optionObject=optionObject
    onIronQuestion=<RadioButton symptom={symptom} onClick={onClick}/>
    }

const riseOnIron=()=>
    {
    let symptom={}
    symptom.name="riseOnIron"
    symptom.label=`Has the patient's haemoglobin rise by at least ${idaThresholds.hbRiseIron}g/l on iron replacement?` 
    symptom.optionObject=optionObject
    riseOnIronQuestion=<RadioButton symptom={symptom}/>
    }

    onIron()
    riseOnIron()  


const onSubmit=(values)=>
{
props.setIronReplacement(values.onIron === "Yes" ? true : false)
props.setRiseWithIron(values.riseOnIron === "Yes" ? true : false)
props.setIronReplacementSubmitted(true)
}

return(<Box>
<Formik
initialValues={initialValues}
onSubmit={onSubmit}
innerRef={formValues}>
<Form>
{onIronQuestion}
{isOnIron==="Yes" && riseOnIronQuestion  }

<Button type="submit"variant="contained">Continue </Button>
</Form>
</Formik>


</Box>)
}

export default IronReplacement